import * as React from "react";
import type { SVGProps } from "react";

interface GreenCardProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const GreenCard = ({ cancelled = false, ...props }: GreenCardProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(3 2)">
      <path
        stroke="#FFF"
        strokeWidth={1.75}
        d="M10-.875c.518 0 .987.21 1.326.55.34.338.549.807.549 1.325v.625H13.5c.518 0 .987.21 1.326.55.34.338.549.807.549 1.325v.625H17c.518 0 .987.21 1.326.55.34.338.549.807.549 1.325v13c0 .518-.21.987-.55 1.326-.338.34-.807.549-1.325.549H8a1.87 1.87 0 0 1-1.326-.55A1.87 1.87 0 0 1 6.125 19v-.625H4.5a1.87 1.87 0 0 1-1.326-.55 1.87 1.87 0 0 1-.549-1.325v-.625H1a1.87 1.87 0 0 1-1.326-.55A1.87 1.87 0 0 1-.875 14V1c0-.518.21-.987.55-1.326C.012-.666.481-.875 1-.875Z"
      />
      <rect
        width={12}
        height={16}
        x={-0.5}
        y={-0.5}
        fill="#FF1212"
        stroke="#000"
        rx={1}
      />
      <rect
        width={12}
        height={16}
        x={3}
        y={2}
        fill="#FFE42B"
        stroke="#000"
        rx={1}
      />
      <rect
        width={12}
        height={16}
        x={6.5}
        y={4.5}
        fill="#60B100"
        stroke="#000"
        rx={1}
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default GreenCard;
